import React, {
    createContext,
    useContext,
    useEffect,
    useState
} from 'react';
import { hot } from 'react-hot-loader';
import { useMutation, useLazyQuery } from '@apollo/client';
import { connect } from 'react-redux';
import { getLongFromShortCode } from '@homeaway/google-address-parser';
import { TrackingContext } from '@vrbo/react-event-tracking';
import {
    defaultProps, mapDispatchToProps, mapStateToProps, proptypes
} from './properties';
import { CREATE_JOIN_MUTATION, FETCH_SUBMARKET_ID } from './graphql/query';
import withPageFlow from '../../components/PageFlow/PageFlow';
import { UserCtx } from '../user';
import { JOIN_HANDLER } from '../../components/PageFlow/PageList';
import { buildContactPayload } from './utils';


import JelCallbackFns from './utils/JELflow';
import AapCallbackFns from './utils/AAPflow';
import { ExperimentCtx } from '../experiments';
import { EGTNL_TESTS_KUMO } from '../../../server/api/abacus/constants';
import log from '../../utils/ClientLogger';

export const JoinCtx = createContext();

export const JOIN_SOURCES = {
    JOIN: 'JOIN',
    AAP: 'ADDPROPERTY'
};

const isAAPFlow = source => source === JOIN_SOURCES.AAP;

export const JoinHandler = (props) => {
    const {
        children
    } = props;

    const { epcUserId, paperContractUser } = useContext(UserCtx);
    const { experimentEvaluations } = useContext(ExperimentCtx);
    const {
        [EGTNL_TESTS_KUMO.ULX_SALESFORCE_IN_LYPS]: lypsSalesforceExperiment
    } = experimentEvaluations || {};
    const { trigger } = useContext(TrackingContext);

    const [loading, setLoading] = useState(false);

    // eslint-disable-next-line no-unused-vars
    const [createContact, createContactState] = useMutation(CREATE_JOIN_MUTATION);

    const [submarketIdResponse, setSubmarketIdResponse] = useState(undefined);
    const onCompleteSubmarketId = ({ fetchSubmarketId }) => {
        setSubmarketIdResponse(fetchSubmarketId);
    };

    const { setSubmarketId } = props;
    useEffect(() => {
        setSubmarketId(submarketIdResponse);
    }, [submarketIdResponse]);

    const onErrorSubmarketId = (error) => {
        log(['error'], 'FetchSubmarketId', error);
        setSubmarketIdResponse(undefined);
    };

    const [fetchSubmarketId, fetchSubmarketIdState] = useLazyQuery(FETCH_SUBMARKET_ID, {
        onCompleted: onCompleteSubmarketId,
        onError: onErrorSubmarketId
    });

    useEffect(() => {
        setLoading(createContactState.loading || fetchSubmarketIdState.loading);
    }, [
        createContactState.loading,
        fetchSubmarketIdState.loading
    ]);


    const createJoin = async (source) => {
        const { setJoinId, setPropertyId } = props;
        setJoinId('');
        setPropertyId('');
        const { managerInfo, chainInfo } = props;
        const contact = buildContactPayload({
            ...props,
            source,
            epcUserId,
            isPaperContractUser: paperContractUser,
            managerInfo: isAAPFlow(source) ? 'no' : managerInfo,
            chainInfo: isAAPFlow(source) ? 'no' : chainInfo,
            lypsSalesforceExperiment
        });

        const {
            onComplete,
            onError
        } = source === JOIN_SOURCES.JOIN ? JelCallbackFns : AapCallbackFns;
        await createContact({
            variables: {
                contact
            }
        }).then(onComplete({ ...props, trigger }), onError({ ...props, trigger }))
            .catch(onError({ ...props, trigger }));
    };

    const triggerSubmarketIdFetch = () => {
        const { address, latLngDetails } = props;
        fetchSubmarketId({
            variables: {
                address: {
                    country: getLongFromShortCode(address?.country.toUpperCase()),
                    latitude: latLngDetails.latitude,
                    longitude: latLngDetails.longitude
                },
                lypsIntegration: lypsSalesforceExperiment === 1
            }
        });
    };
    return (
        <JoinCtx.Provider value={{
            createJoin,
            loading,
            triggerSubmarketIdFetch
        }}
        >
            {children}
        </JoinCtx.Provider>
    );
};

JoinHandler.propTypes = proptypes;
JoinHandler.defaultProps = defaultProps;
const connectedJoinHandler = connect(mapStateToProps, mapDispatchToProps)(JoinHandler);

connectedJoinHandler.displayName = JOIN_HANDLER;
export default hot(module)(withPageFlow(connectedJoinHandler));
